import { LicenseInfo } from '@mui/x-license'

/**
 * Register the MUI X Premium licence.
 *
 * Must run before any DataGrid renders, so this is imported for its side
 * effect from main.tsx ahead of everything else.
 *
 * The key is not a security secret — MUI validates it in the browser, so it
 * is visible in the bundle of any deployed MUI X application by design. It is
 * paid for, though, so it comes from the environment and is never committed:
 * `.env` locally, the `MUI_LICENSE_KEY` repository secret in CI.
 *
 * Without a key the grid still works, showing a watermark and a console
 * warning, so a missing key never blocks development.
 */
const key = import.meta.env.VITE_MUI_LICENSE_KEY

if (key) {
  LicenseInfo.setLicenseKey(key)
} else if (import.meta.env.PROD) {
  // In production a missing key means the build was misconfigured — the
  // watermark would be the first anyone hears of it.
  console.error(
    'VITE_MUI_LICENSE_KEY was not set at build time. The data grid will ' +
      'render with a licence watermark. Check the MUI_LICENSE_KEY repository ' +
      'secret and the Build step in .github/workflows/deploy.yml.',
  )
}
